import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MethodsSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.methods', { returnObjects: true }) as any;
  const [activeTag, setActiveTag] = useState(0);

  return (
    <div className="dt-mockup-methods">
      <div className="dt-methods-toolbar">
        <span className="dt-methods-toolbar-title">{m.toolbarTitle}</span>
        <span className="dt-methods-toolbar-badge">{m.toolbarBadge}</span>
      </div>
      <div className="dt-methods-search">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
        </svg>
        <span>{m.search}</span>
      </div>
      <div className="dt-methods-tags">
        {m.tags.map((tag: string, i: number) => (
          <button
            key={tag}
            className={`dt-methods-tag ${i === activeTag ? 'dt-methods-tag--active' : ''}`}
            onClick={() => setActiveTag(i)}
          >
            {tag}
          </button>
        ))}
      </div>
      <div className="dt-methods-list">
        {m.items.map((item: any, i: number) => (
          <div key={item.name} className={`dt-methods-item ${i === 0 ? 'dt-methods-item--highlighted' : ''}`}>
            <div className="dt-methods-item-top">
              <span className="dt-method-icon">{item.icon}</span>
              <div className="dt-methods-item-name">{item.name}</div>
              <span className="dt-method-rating">★ {item.rating}</span>
            </div>
            <div className="dt-methods-item-meta">
              <span className="dt-methods-item-cat">{item.cat}</span>
              <span>•</span>
              <span>{item.duration}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MethodsSlide;
